<template>
  <td>
    <v-button @click.native="update()" class="btn-primary" :working="loading">
      {{ label || "Update" }}
    </v-button>
  </td>
</template>

<script lang="babel">
export default {
  props: ['attribute', 'content', 'label', 'model'],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    update() {
      this.loading = true;
      this.$store.dispatch(`cache/update`, { url: '/api/v1/cache/', data: {cache: this.content}})
        .then(() => {
          this.$notify({
            title: this.attribute.notification || 'Cache wurde geupdated',
            type: "success"
          });        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    resource() {
      const url = this.model.update_url.split('/');

      return url[url.length - 2];
    }
  }
};
</script>
